import React, { Component } from 'react';
import PropTypes from 'prop-types';
import url from 'url';

export default class Router extends Component {
  static updateQuery = (update, push = false) => {
    Router.listeners.forEach((cb) => {
      if (typeof cb === 'function') {
        cb(update, push);
      }
    });
  }

  constructor(props) {
    super(props);
    const { location } = this.props;
    this.state = {
      location: {
        hash: location.hash,
        pathname: location.pathname,
        query: location.query,
      },
    };
  }


  componentDidMount() {
    Router.listeners.push(this.updateQuery);
  }

  updateQuery = (update, push = false) => {
    const { location: stateLocation } = this.state;
    const { history } = this.props;

    const location = {
      ...stateLocation,
      query: {
        ...stateLocation.query,
      },
    };
    Object.keys(update).forEach((key) => {
      location.query[key] = update[key].toString();
    });
    this.setState({ location });

    if (push) {
      history.push(url.format(location));
    } else {
      history.replace(url.format(location));
    }
  }

  static listeners = [];


  render() {
    const { children } = this.props;
    const { location } = this.state;

    const childrenWithProps = React.Children.map(children, (child) => React.cloneElement(child, { location }));

    return <div>{childrenWithProps}</div>;
  }
}

Router.propTypes = {
  location: PropTypes.shape({
    hash: PropTypes.string,
    pathname: PropTypes.string,
    query: PropTypes.shape({}),
  }),
  children: PropTypes.node,
  history: PropTypes.shape({
    push: PropTypes.func,
    replace: PropTypes.func,
  }),
};
